import { useState } from "react";
import { Accordion } from "react-bootstrap";
import Select from 'react-select';
import { FORM_KEYS, getAge, getPolicyMembers } from "./helper";
import AsteriskSymbol from "../../../../reusableComponents/AsteriskSymbol";
import { format } from 'date-fns';

const PatientDetails = ({ formData, setValue, customStyles, policyData }) => {
    const [patients, setPatients] = useState([])
    const [noOptionPlaceholder, setNoOptionPlaceHolder] = useState(
        "Minimum 3 characters required"
    );
    const policyHolders = getPolicyMembers(policyData)
    const getPatients = (value) => {
        let filteredPatient = []
        if (value.length >= 3) {
            filteredPatient = policyHolders?.filter(policyHolder => policyHolder.name?.toLowerCase().includes(value.toLowerCase()))
            if (!filteredPatient?.length) {
                setNoOptionPlaceHolder("Search results not found");
            }
            setPatients(filteredPatient?.map(patient => ({
                value: patient,
                label: patient.name
            })))
        } else if (value.length > 0) {
            setNoOptionPlaceHolder("Minimum 3 characters required")
            setPatients([])
        }
    }
    return <>
        <Accordion className='accordion m-2' defaultActiveKey="0">
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    Patient Details
                </Accordion.Header>
                <Accordion.Body>
                    <div className="row row-gap-3">
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="align3Policy">Patient Name <AsteriskSymbol /></p>
                            <Select
                                options={patients}
                                classNamePrefix="truncate-placeholder"
                                placeholder="Select Patient Name"
                                value={formData[FORM_KEYS.patient]}
                                onChange={(data) => {
                                    setValue(FORM_KEYS.patient, data)
                                }}
                                onInputChange={(inputValue) => {
                                    getPatients(inputValue);
                                }}
                                noOptionsMessage={() => noOptionPlaceholder}
                                styles={customStyles}
                            />
                        </div>
                        {policyHolders?.length > 1 && (
                            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                <p className="align3Policy">Patient Relationship</p>
                                <input
                                    className="claim-intimator-textarea mt-2 ms-2"
                                    placeholder="Relationship"
                                    value={formData[FORM_KEYS.patient]?.value?.relation || "--"}
                                    disabled
                                />
                            </div>)}

                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="align3Policy">Date of Birth</p>
                            <input
                                className="claim-intimator-textarea mt-2 ms-2"
                                placeholder="Date of birth"
                                value={formData[FORM_KEYS.patient]?.value?.dob ? format(formData[FORM_KEYS.patient]?.value?.dob, "dd-MM-yyyy") : "--"}
                                disabled
                            />
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="align3Policy">Age</p>
                            <input
                                className="claim-intimator-textarea mt-2 ms-2"
                                placeholder="Age"
                                value={formData[FORM_KEYS.patient]?.value?.dob ? getAge(format(formData[FORM_KEYS.patient]?.value?.dob, "dd-MM-yyyy")) : "--"}
                                disabled
                            />
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="align3Policy">Gender</p>
                            <input
                                className="claim-intimator-textarea mt-2 ms-2"
                                placeholder="Gender"
                                value={formData[FORM_KEYS.patient]?.value?.gender || "--"}
                                disabled
                            />
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="align3Policy">Member ID</p>
                            <input
                                className="claim-intimator-textarea mt-2 ms-2"
                                placeholder="Member ID"
                                value={formData[FORM_KEYS.patient]?.value?.member_id || "--"}
                                disabled
                            />
                        </div>

                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                            <p className="align3Policy">Alternate Mobile Number</p>
                            <input
                                type="tel"
                                className="align3_dataPolicy mt-3"
                                name="tel"
                                id="tel"
                                placeholder="Enter Alternate Mobile Number"
                                maxLength={10}
                                onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                    e.target.value = numericValue;
                                    setValue(FORM_KEYS.alternate_mobile_number, e.target.value)
                                }}
                                value={formData[FORM_KEYS.alternate_mobile_number]}
                            />
                        </div>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    </>
}
export default PatientDetails;